module.exports = "skills-ribbon"